// extracted by mini-css-extract-plugin
module.exports = {"withoutDialog":"_1GDQR","withDialog":"_3wjeq"};